const ANNOUNCEMENTS_BASE_PATH = `${process.env.PUBLIC_URL || ""}/Markdown/Announcements`;
const ANNOUNCEMENTS_DEFAULT_LANGUAGE = "EN";

function normalizeAnnouncementLanguageCode(language) {
  const primaryCode = String(language || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  if (!primaryCode) {
    return ANNOUNCEMENTS_DEFAULT_LANGUAGE;
  }

  return primaryCode.toUpperCase();
}

function normalizeAnnouncementContentKey(contentKey) {
  const normalized = String(contentKey || "").trim();
  if (!normalized || !/^[A-Za-z0-9_-]+$/.test(normalized)) {
    return "";
  }

  return normalized;
}

function buildAnnouncementMarkdownUrl(contentKey, languageCode) {
  const normalizedContentKey = normalizeAnnouncementContentKey(contentKey);
  if (!normalizedContentKey) {
    return "";
  }

  return `${ANNOUNCEMENTS_BASE_PATH}/${normalizedContentKey}/${languageCode}.md`;
}

function getAnnouncementMarkdownCandidates(contentKey, language) {
  const preferredLanguage = normalizeAnnouncementLanguageCode(language);
  const candidates = [
    buildAnnouncementMarkdownUrl(contentKey, preferredLanguage),
    buildAnnouncementMarkdownUrl(contentKey, ANNOUNCEMENTS_DEFAULT_LANGUAGE),
  ].filter(Boolean);

  return [...new Set(candidates)];
}

async function fetchAnnouncementMarkdownWithFallback(contentKey, language, options) {
  const candidates = getAnnouncementMarkdownCandidates(contentKey, language);
  if (!candidates.length) {
    throw new Error("Announcement content key is missing or invalid");
  }

  let lastError = null;

  for (const url of candidates) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(
          `Failed loading announcement markdown: ${response.status}`
        );
      }

      const markdown = await response.text();
      if (markdown.trim()) {
        return markdown;
      }

      lastError = new Error(`Announcement markdown file is empty: ${url}`);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Failed loading announcement markdown");
}

export {
  fetchAnnouncementMarkdownWithFallback,
  getAnnouncementMarkdownCandidates,
  normalizeAnnouncementContentKey,
  normalizeAnnouncementLanguageCode,
};
